import { Auth0Provider } from '@auth0/auth0-react';
import { Pages } from './App';

function Auth0App(props: { auth0: any }) {
  return (
    <Auth0Provider
      domain={props.auth0.domain}
      clientId={props.auth0.clientId}
      authorizationParams={props.auth0.authorizationParams}
    >
      <Pages />
    </Auth0Provider>
  );
}

export default Auth0App;
